import {css} from '@emotion/react';

export const videoBackgroundStyle = css`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
`;

export const videoStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: cover;
`;

export const overlayStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  transition: background-color 0.3s ease;
`;

export const vinetteOverlayStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 1)
  );
  z-index: 2;
`;
